








import { Component, Vue } from "vue-property-decorator";
import SunFooter from "@/components/SunFooter.vue"

@Component({
     components: { SunFooter },
})
export default class App extends Vue {}
